import React from "react"
import Cabecalho from "../Cabecalho"
import { BrindesLista } from "./components/BrindesLista"

export function BrindesFornecedor() {
    return (
        <>
            <Cabecalho pagina="Promoções" />
            <BrindesLista />
        </>
    )
}
